export default "__VITE_ASSET__GsLwNeax__";